const mockFeatureRequestsData =  [
    {
        "id": 7,
        "release": 41,
        "dj_tastemaker": "gew",
        "radio_support": "gew",
        "marketing_pr": "gew",
        "label_reach": "ewg",
        "artist_remixer": "",
        "label": "Sub User Label",
        "release_name": "Rising Silhouette",
        "release_date": "2021-12-15",
        "exclusive_date": null,
        "release_artist_name": "Felix Lyric"
    },
    {
        "id": 8,
        "release": 43,
        "dj_tastemaker": "gds",
        "radio_support": "gds",
        "marketing_pr": "gds",
        "label_reach": "gds",
        "artist_remixer": "",
        "label": "Test Records",
        "release_name": "Melodic Harmony",
        "release_date": "2021-11-25",
        "exclusive_date": null,
        "release_artist_name": "Aster Veldt"
    }
];
export default mockFeatureRequestsData;